module.exports = __webpack_public_path__ + "static/media/obsluga-klienta.2174ee79.svg";